import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textTruncate',
})
export class TextTruncatePipe implements PipeTransform {
    transform(text: string, allowedLength: number | undefined): string {
        if (!text || !allowedLength) return '';
        return text.length > allowedLength ? text.substring(0, allowedLength) + '...' : text;
    }
}
